import React from 'react';
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import modal from '../utils/modal';

const StyledFooter = styled.footer`
  padding-top: 20px;
  padding-bottom: 20px;
  //img {
  //  height: 80px;
  //  width: auto;
  //  margin-bottom: 20px;
  //}
  //li {
  //  list-style-type: none;
  //  font-size: 12px;
  //  line-height: 15px;
  //}
  .row {
    position: relative;
    height: 100%;
  }
  .link-container {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .btn-link {
    font-size: 12px;
    line-height: 15px;
  }
`
export default function Footer() {
  const { t } = useTranslation();

  const { image } = useStaticQuery(
    graphql`
        query {
            image: file(sourceInstanceName: { eq: "images" }, name:{ eq: "unito"} ) {
                id
                name
                childImageSharp {
                    fixed(
                        height: 80
                    ) {
                        ...GatsbyImageSharpFixed
                    }
                }
            }
        }
    `
  );
  async function showInformation() {
    await modal.fire({
      width: '99vw',
      title: t('common.participant_information.title'),
      html: t('common.participant_information.body'),
    });
  }
  return (
    <StyledFooter className="container">
      <div className="row">
        <div className="col-md-4">
          <Img
            fixed={image.childImageSharp.fixed}
            alt="Università degli studi di Torino"
            // style={{ marginTop: 25 }}
          />
        </div>
        <div className="col-md-8 link-container text-right">
          <button type="button" className="btn-link btn-anchor" onClick={() => showInformation()}>
            {t('common.participant_information.title')}
          </button>
        </div>
      </div>
    </StyledFooter>
  );
}
